/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import {
  modalController,
} from '@ionic/vue';
import NoNetwork from '../components/NoNetwork/NoNetwork.vue';

const openNoConnectivityModalHandle = () => modalController
  .create({
    component: NoNetwork,
    backdropDismiss: false,
    keyboardClose: false,
    cssClass: 'fullscreen connectivitymodal',
  })
  .then((modalElement) => {
    modalElement.present();
    modalElement.onDidDismiss();
  });

export {
  openNoConnectivityModalHandle,
};
